import * as React from 'react';
import './index.scss';

export default function Index(props: { afterSaleTemplateId: any; industry: any; }) {
  const {afterSaleTemplateId, industry} = props;
  return (
    <div id="after-service"></div>
  )
}